import React, { Component } from 'react';
import './Cart--Item.css';

import { API_BASE } from '../config';

import cookie from 'react-cookies';

import Input from './Input';
import Notification from '../components/Notification';

class CartItem extends Component {

  constructor(props) {
    super(props);

    this._removeItem = this._removeItem.bind(this);
    this._updateQuantity = this._updateQuantity.bind(this);

    this.state = {
      cart_item:this.props.cart_item,
      quantity:this.props.cart_item.quantity,
      notification_text:"",
      store:this.props.store
    };

  }

  componentWillReceiveProps(newProps) {

    this.setState({
      cart_item:newProps.cart_item,
      quantity:newProps.cart_item.quantity,
      store:newProps.store
    });

  }

  render() {
    
    var cartRowImageStyle = {
      backgroundImage:"url('"+this.state.cart_item.image+"')",
      backgroundSize:"cover",
      backgroundRepeat:"none",
      backgroundPosition:"50% 50%"
    }

    return (
      
      <div className="Page cartRow" id={this.state.cart_item.product_id}> 
        
        <Notification text={this.state.notification_text} />

        <div className="cartRow-image" style={cartRowImageStyle}>
          <a onClick={this._removeItem}>&#215;</a>
        </div>

        <div className="cartRow-info clearflex align-flex-start">
          <div className="two-thirds column">
            <p><strong>{this.state.cart_item.name}</strong></p>
            <p className="cartRow-info--description">{this.state.cart_item.description}</p>
          </div>
          <div className="one-third column">
            <div>
              <p>${this.state.cart_item.subtotal} &#215;</p>
              <Input type="number" name="quantity" value={this.state.quantity} onBlur={this._updateQuantity} noSave style={{textAlign:"right"}} />
            </div>
            <hr />
            <p>
              <strong>$<span className="total">{this.state.cart_item.total}</span></strong>
            </p>
          </div>
        </div>

        {this.state.cart_item.store_id !== this.state.store.id ?
          <div className="cartRow-info cartRow-info-alt clearflex justify-flex-start">
            <p style={{background:"white",borderRadius:"50%",height:"3.25em",lineHeight:"calc(3.25em - 10px)",padding:"5px",width:"3.25em",marginRight:"10px"}}>{this.state.cart_item.store_logo ? <img src={this.state.cart_item.store_logo} alt={"Made by "+this.state.cart_item.store_name} style={{borderRadius:"50%"}} /> : null }</p>
            <p style={{width:"calc(100% - 3.5em - 10px)"}}>Made by <a href={"https://shop.reallysimplestore.com/"+this.state.cart_item.store_permalink} target="_blank">{this.state.cart_item.store_name}</a></p>
          </div>
        : null }

      </div>
            
    );  
  
  }

  _removeItem() {
    this._updateQuantity("quantity","0");
  }

  _updateQuantity(name,value) {
    
    if (this.state[name] !== value) { // only fire if quantity was updated
      this.setState({
        quantity:value,
        notification_text:"Updating..."
      });

      var _this = this;

      var cart_token = cookie.load(_this.props.store.permalink.toLowerCase());
      var request = new Request(`${API_BASE}cart/update/`+this.state.cart_item.product_id+"/"+value+"?cart_token="+cart_token, {
        method: 'PUT', 
        mode: 'cors'
      });

      fetch(request).then(function(response) {
        return response.json();
      }).then(function(json) {
        //console.log('parsed json', json);
        
        _this.props.updateCart();

        _this.setState({
          notification_text:json.success || json.error
        })

      }).catch(function(ex) {
        console.log('parsing failed', ex);
      });
    }


  }

}

export default CartItem;


// WEBPACK FOOTER //
// ./src/components/Cart--Item.js